import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { PwaInstallService } from '../services/pwa-install.service';

@Component({
    selector: 'app-pwa-install-prompt',
    templateUrl: './pwa-install-prompt.component.html',
    styleUrls: ['./pwa-install-prompt.component.scss']
})
export class PwaInstallPromptComponent implements OnInit, OnDestroy {
    visible = false;
    private subscription?: Subscription;

    constructor(private readonly pwaInstallService: PwaInstallService) { }

    ngOnInit(): void {
        this.subscription = this.pwaInstallService.canInstall$.subscribe((canInstall) => {
            this.visible = canInstall;
        });
    }

    ngOnDestroy(): void {
        this.subscription?.unsubscribe();
    }

    install(): void {
        this.pwaInstallService.promptInstall();
    }

    dismiss(): void {
        this.pwaInstallService.dismissForNow();
    }
}
